<template>
  <div class="p-4 flex-grow-1 overflow-auto bg-home-new">
    <div v-loading="menuLoading" class="menu">
      <el-row :gutter="20" class="p-4" id="menu-row">
        <el-col
        v-for="(menu, idx) in visibleMenus"
        :key="idx"
          :xs="12"
          :sm="8"
          :md="6"
          :lg="4"
          :xl="3"
        >
          <el-button type="primary" class="btn-menu btn-color bg-company" @click="menu.onClick">
            <div class="mb-3">
              <img :src="menu.icon" alt="layout" />
            </div>
            <div class="title-menu">
              {{ menu.label }}
            </div>
          </el-button>
        </el-col>
      </el-row>
    </div>
    <div v-loading="menuLoading">
        <div v-loading="gettingCatgories" class="p-4 pt-0" style="height: 93vh" element-loading-background="transparent">
          <!-- Product category overview -->
          <div>
            <div class="d-flex justify-content-between align-items-center w-100 p-4 pt-5">
              <h4 class="fw-bold mb-0">{{ $t('views.configurator.step0') }}</h4>
              <div class="w-25">
                <el-input v-model="searchText" :placeholder="$t('views.template.search')" />
              </div>
            </div>
            <!-- Product categories -->
            <div class="p-2 ps-4 product-grid">
              <div v-for="product in productTypeWithFilter" :key="product.productId" class="product-card__wrapper home-card">
                <product-card
                  :title="$t(`enum.product-type.${product.type.name}`) || product.type.name"
                  :primary-button-text="$t('views.customize.workflow.productOverview.productCardButton')"
                  @button-clicked="this.router.push(`/configurator?productTypeId=${product.type.productTypeId}`)"
                >
                  <preview-renderer-img
                    :meshes="[
                      {
                        thumbnail: product.name,
                        thumbnailUrl: product.thumbnail.content,
                      },
                    ]"
                    img-size="5"
                    width="80%"
                  />
                </product-card>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
  <Footer :is-editor="false" class="p-4" />
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-facing-decorator';
import Cookies from 'js-cookie';

import { Role } from '@/types/enum/user';
import Header from '../../components/layout/Header.vue';
import Footer from '../../components/layout/Footer.vue';
import { Key } from '@/types/constants/Key';
import { useUserStore } from '@/stores/userStore';
import { useProductStore } from '@/stores/productStore';
import * as modelService from '@/services/api/modelService';
import { useRoute, useRouter } from 'vue-router';
import { Product } from '@/types/api/Model/Product';
import ProductCard from '@/components/layout/sidebar/ProductCard.vue';
import PreviewRendererImg from '@/components/features/previewRenderer/PreviewRendererImg.vue';
import i18n from '@/i18n';
import layoutIcon from '@/assets/icons/layout.svg';
import customizeIcon from '@/assets/icons/layers_w.svg';
import projectIcon from '@/assets/icons/customize.svg';
import uploadIcon from '@/assets/icons/upload_w.svg';
import { defaultUrlSuffix } from '@/types/constants/url-suffix';
import { ElMessageBox } from 'element-plus';
import { Model2 } from '@/types/api/Model/Model';
import { useFeatureFlagStore } from '@/stores/featureFlagStore';

@Component({
  components: {
    Header,
    Footer,
    ProductCard,
    PreviewRendererImg,
  },
})

export default class Home extends Vue {
  @Prop() supplierUrl!: string;

  menuLoading = false;
  Role = Role;
  authSystemCheck = false;
  userStore = useUserStore();
  router = useRouter();
  route = useRoute();
  gettingCatgories = false;
  productTypeList: Product[] = [];
  isHomePage = false;
  productStore = useProductStore();
  featureFlagStore = useFeatureFlagStore();
  searchText = '';

  confirmToLogin(): void {
    ElMessageBox.confirm(
      i18n.global.t('confirm.redirectLogin.message'),
      i18n.global.t('confirm.redirectLogin.title'),
      {
        confirmButtonText: i18n.global.t('confirm.redirectLogin.ok'),
        cancelButtonText: i18n.global.t('confirm.redirectLogin.cancel'),
        type: 'warning',
      }
    )
    .then(() => this.router.push('/login'))
    .catch(() => false);

  }

  navigateToPage(route: string) {
    if (!this.userStore.isAuthenticated) {
      this.confirmToLogin()
      return;
    }
    this.router.push({ name: route });
  }

  get menus() {
    return [
       {
        label: i18n.global.t('views.configurator.yourProjects'),
        icon: projectIcon,
        onClick: () => this.navigateToPage('projects'),
        // show: this.userStore.roles.includes(Role.Supplier),
        show: this.featureFlagStore.isProjectListEnabled(),
      },
      {
        label: i18n.global.t('views.configurator.templates'),
        icon: layoutIcon,
        onClick: () => this.navigateToPage('templates'),
        // show: this.userStore.roles.includes(Role.Supplier),
        show: this.featureFlagStore.isTemplateListEnabled(),
      },
      {
        label: i18n.global.t('views.configurator.upload'),
        icon: uploadIcon,
        onClick: () => this.navigateToPage('template-upload'),
        show: this.featureFlagStore.isTemplateUploadEnabled(),
      },
      
      {
        label: i18n.global.t('views.default.overview.customize'),
        icon: customizeIcon,
        onClick: () => {
          this.router.push({ name: 'configurator' });
        },
        show: this.featureFlagStore.isConfiguratorOrderEnabled(),
      },
    ];
  }

  get visibleMenus() {
    return this.menus.filter(menu => menu.show);
  }

  created(): void {
    const token = Cookies.get(Key.cookie.access_token_key);
    if (token) {
      this.authSystemCheck = true;
    }
  }

  async handleGetProductTypeListWithUserId(userId: number, productTypeIds: number[]): Promise<void> {
    try {
      // fetch model data 
      const responseModels = await modelService.getModelsByUserId({userId});

      // filtering to get only productType list 
      const modelList = responseModels.filter(item => !item.basedOn && productTypeIds.includes(item.product.type.productTypeId))
      const productTypes = this.getProductTypes(modelList);

      // save to state 
      this.productStore.setProductTypes(productTypes);
      this.productTypeList = productTypes;
      this.gettingCatgories = false;
    } catch (error) {
      console.error('getModelsByUserId error ~', error)
    }
    
  }

  async handleGetProductTypeList(urlSuffix: string = ''): Promise<void> {
    
    // Get urlSuffix as parameter 
    const domainUrlSuffix = urlSuffix.length > 0 
      ? urlSuffix 
      : defaultUrlSuffix;
    
    try {
      // fetch model data 
      const responseModels = await modelService.getModelsByUrlSuffix(domainUrlSuffix, null);
      
      // filtering to get only productType list 
      const modelList = responseModels.filter((item) => !item.basedOn);
      const productTypes = this.getProductTypes(modelList);

      // save to state 
      this.productStore.setProductTypes(productTypes);
      this.productTypeList = productTypes;
      this.gettingCatgories = false;

    } catch (error) {
      console.error('getModelsByUrlSuffix error ~', error)
    }

  }

  async mounted(): Promise<void> {
    this.gettingCatgories = true;

    const domain = this.userStore.domain;
    const userPk = this.userStore.user?.pk;

    try {
        if (domain && domain.urlSuffix.length > 0 && userPk) {
            const { urlSuffix } = domain;
            const productTypeIds = await modelService.getAllProductTypeIdsByUrlSuffix(urlSuffix);
            await this.handleGetProductTypeListWithUserId(userPk, productTypeIds);
        } else if (domain && domain.urlSuffix.length > 0) {
            const { urlSuffix } = domain;
            await this.handleGetProductTypeList(urlSuffix);
        } else {
            await this.handleGetProductTypeList();
        }
    } catch (error) {
        console.error('Failed to get product list:', error);
    } finally {
        this.gettingCatgories = false;
    }
  }
  
  getProductTypes(modelList: Model2[]): Product[] {
    const productTypeList: Product[] = [];
    
    for (const model of modelList) {
      const productTypeId = productTypeList.findIndex((pt) => 
        pt.type.productTypeId == model.product.type.productTypeId
      );

      if (productTypeId === -1) {
        productTypeList.push(model.product);
      }
    }

    return productTypeList;
  }

  get productTypeWithFilter(): Product[] {
    if (this.searchText.length > 0) {
      return this.productTypeList.filter((item) => 
        item.type.name
          .toLowerCase()
          .includes(this.searchText.toLowerCase()
      ));
    }

    return this.productTypeList;
  }

  handleLogout() {
    Cookies.remove(Key.cookie.access_token_key);
    window.location.reload();
  }
}
</script>

<style lang="scss" scoped>
h1 {
  margin-top: 5rem;
  margin-bottom: 3rem;
  text-align: center;
}
.bg-home-new {
  background-color: transparent;
  height: 100vh;
}
#menu-row{
  background: url('/public/assets/no-image.jpg');
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding: 48px !important;
}
.header-text {
  color: #1d1e19;
  margin-bottom: 0;
  font-size: 30px;
}
.header-text-auth {
  margin-top: 0;
  font-weight: 400;
  font-size: 22px;
  text-align: center;
  color: #1d1e19;
}
.menu {
  .el-row {
    justify-content: center;
  }
}
.btn-menu {
  width: 100% !important;
  border-radius: 6px;
  height: auto !important;

  img{
    width: 42px;
  }
}
.btn-color {
  background: var(--color-primary) !important;
  border-color: var(--color-primary) !important;
}
.header-wrapper {
  margin-bottom: 60px;
}

.title-menu {
  font-size: 16px;
}
.el-button :deep() {
  display: block;
  padding: 1rem;
  height: 9rem;
  width: 9rem;
  margin: 0.5rem;
  white-space: normal;

  > span {
    display: block;
  }

  svg {
    font-size: 3.5rem;
    padding-bottom: 0.5rem;
  }
}

.product-grid {
  display: flex;
  flex-wrap: wrap; /* Allows wrapping when max-width is reached */
  justify-content: flex-start; /* Aligns items to the left */
  gap: 0.8rem;
  padding: 1.58rem;
  max-width: 90vw;
}

.product-card__wrapper {
  height: fit-content;
  width: fit-content;
  justify-content: flex-start;
}

@media (max-width: 480px) {
  .menu {
    margin: auto;
    width: 100%;
  }
  .btn-menu {
    height: 160px !important;
    width: 150px !important;
  }
}
</style>

<style lang="scss">
.home-card{
  .card-body{
    img{
      width: 100% !important;
    }
  }
}
</style>